import { VStack } from '@chakra-ui/layout'
import { Box, Divider, Text as ChakraText } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { BiVideo } from 'react-icons/bi'
import { GrImage as GrImageIcon } from 'react-icons/gr'
import { MdTransform } from 'react-icons/md'
import styled, { createGlobalStyle } from 'styled-components'
import { colors } from '../../../ui-kit'
import { SideBar } from '../../layouts/Base'
import { SideBarItem } from '../../layouts/Base/SideBar'

const GrImage = styled(GrImageIcon)`
  path {
    stroke: ${props => props.stroke};
  }
`

const ActiveLinkStyles = createGlobalStyle`
  .active-link {
    ${GrImage} {
      path {
        stroke: ${colors.appSlate};
      }
    }

    :not(${GrImage}) {
      svg {
        fill: ${colors.appSlate};
      }
    }
    p {
      color: ${colors.appSlate};
    }
  }
`

const SideMenu = (): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <SideBar heading={t('analytics', 'Analytics')}>
      <ActiveLinkStyles />
      <VStack
        overflow="auto"
        h="100%"
        spacing="1em"
        padding="1.5em 0.75em 1.5em"
      >
        <SideBarItem
          to="/analytics/overall-usage"
          activeClassName="active-link"
        >
          <Box margin="1rem">
            <GrImage fontSize="2rem" stroke={colors.appBattleshipGrey} />
          </Box>
          <ChakraText
            fontSize="md"
            fontWeight="500"
            color={colors.appBattleshipGrey}
            lineHeight="4rem"
          >
            {t('usage_analytics', 'Usage Analytics')}
          </ChakraText>
        </SideBarItem>
        <Divider />
        <SideBarItem to="/analytics/media-usage" activeClassName="active-link">
          <Box margin="1rem">
            <BiVideo fontSize="2rem" fill={colors.appBattleshipGrey} />
          </Box>
          <ChakraText
            fontSize="md"
            fontWeight="500"
            color={colors.appBattleshipGrey}
            lineHeight="4rem"
          >
            {t('media_use_analysis', 'Media use analysis')}
          </ChakraText>
        </SideBarItem>
        <Divider />
        <SideBarItem
          to="/analytics/error-reports"
          activeClassName="active-link"
        >
          <Box margin="1rem">
            <MdTransform fontSize="2rem" fill={colors.appBattleshipGrey} />
          </Box>
          <ChakraText
            fontSize="md"
            fontWeight="500"
            color={colors.appBattleshipGrey}
            lineHeight="4rem"
          >
            {t('error_reports', 'Error Reports')}
          </ChakraText>
        </SideBarItem>
        <Divider />
      </VStack>
    </SideBar>
  )
}

export default SideMenu
